<template>
    <div id="router-view">
        <vue-snotify></vue-snotify>
        <router-view />
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'App',
    created: function () {},
    computed: {
        ...mapState({
            loggedUserParams: (state) => state.loggedUser.params
        })
    },
    watch: {
        loggedUserParams: {
            handler() {
                if (this.loggedUserParams?.Lingua)
                    this.$setLocale(this.loggedUserParams.Lingua.slice(0, 2))
            },
            deep: true,
            immediate: true
        }
    }
}
</script>
